export const SERVICE_NAMES: TStringObject = {
  top3: 'Топ-объявления',
  'premium+highlight': 'Премиум-объявления',
  premium: 'Премиум-объявления',
  'paid+highlight': 'Платные объявления',
  paid: 'Платные объявления',
  free: 'Бесплатные объявления',
};
